export const menuHeightDesktop = 64;
export const menuHeightMobile = 56;
export const filtersHeightDesktop = 60;
export const filtersFooterHeightMobile = 20;
export const statisticsBarWidthDesktop = 600;
export const mapNavigationMarginTop = 10;
export const defaultPageMaxWidth = 1000;
